<template>
  <div id="bubble_block" class="bubble_block" :style="{backgroundImage: `url(${imageSource})`}">
    <div :style="backgroundStyles">
      <component-renderer v-for="field in fields" v-bind:key="field.id" :field="field"/>
    </div>
  </div>
</template>

<script>
import componentRenderer from "@/components/component-renderer";

export default {
  name: "background",
  components: { componentRenderer },
  props: {
    fields: {
      required: false,
      type: Array,
      default: () => []
    },
    imageSource: {
      required: false,
      type: String
    },
    backgroundStyles: {
      required: false,
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
  .bubble_block {
    background-color: #ffffff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    overflow: hidden;
  }
</style>
